import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchFeatureFlagState } from 'src/actions/user';

/**
 * useDetectFeatureEnabled 判断某特性是否开启
 * @param featureName feature名
 * @param shouldCache 是否缓存特性检测结果
 */
export default function useDetectFeatureEnabled(featureName, shouldCache = false) {
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(false);
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    dispatch(
      fetchFeatureFlagState({
        featureName,
        shouldCache,
        detectCallback: (enabled) => {
          setDetected(true);
          setEnabled(enabled);
        },
      })
    );
  }, []);

  return { enabled, detected };
}
